// extracted by mini-css-extract-plugin
export default {"section":"Section_section__t0GDm","header":"Section_header__DS49s","count":"Section_count__UspV5","expand":"Section_expand__F2xIV","fieldsWrapper":"Section_fieldsWrapper__eudOY"};